interface ColorsType {
    primary: string;
    spinner: string;
    skeleton: string;

    ntClrOne: string;
    ntClrTwo: string;
    ntClrThree: string;

    primaryLight: string;
    primaryDark: string;

    text: string;
    subHeading: string;
    heading: string;

    btnDark: string;
    btnDarkHover: string;
    btnDarkActive: string;

    btnGrayDark: string;
    btnGrayDarkHover: string;
    btnGrayDarkActive: string;

    letterSpacing: string;
    borderRadius: string;
}

export const colors: ColorsType = {
    primary: "#b58e57",          // البرونزي الأساسي
    spinner: "#b58e57",
    skeleton: "#e2e8f0",

    // Neutral Colors (الرماديات الفولاذية)
    ntClrOne: "#cbd5e1",         // رمادي معدني فاتح
    ntClrTwo: "#f8fafc",         // خلفية فاتحة جداً
    ntClrThree: "#f1f5f9",       // رمادي بارد للأقسام

    // Primary Palette (تدرجات البرونزي)
    primaryLight: "#dfccad",     // برونزي فاتح
    primaryDark: "#86613e",      // برونزي عميق

    // Text Colors
    text: "#475569",             // نص رمادي داكن مريح للعين
    subHeading: "#334155",       // عناوين فرعية صلبة
    heading: "#1e293b",          // عناوين رئيسية قوية (تقريباً أسود معدني)

    // Dark Button Colors (تدرجات البرونزي للتحفيز)
    btnDark: "#b58e57",          // زر برونزي أساسي
    btnDarkHover: "#a17849",     // برونزي أغمق قليلاً عند التمرير
    btnDarkActive: "#86613e",    // برونزي عميق عند الضغط

    // Gray Button Colors (تدرجات الفولاذ الداكن)
    btnGrayDark: "#1e293b",      // زر رمادي غامق (Steel Gray)
    btnGrayDarkHover: "#334155",
    btnGrayDarkActive: "#0f172a",

    // Values
    letterSpacing: "0.25px",
    borderRadius: "6px",         // تقليل الحواف قليلاً ليعطي طابعاً هندسياً أكثر حدة
};
